import { BillingTransferRequestType } from "@common/constants/domains/billing/billingTransferRequest";
import { z } from "zod";

export const billingTransferRequestSchema = z.object({
    id: z.string(),
    code: z.string(),
    organizationId: z.string(),
    workspaceId: z.string(),
    issuedByUserId: z.number(),
    type: z.nativeEnum(BillingTransferRequestType),
});

export type BillingTransferRequest = z.infer<
    typeof billingTransferRequestSchema
>;
